import type { PublicAsset } from '@im-marina/shared';

/** `srcset` attribute value from a width -> URL map. */
export function toSrcSet(srcset: PublicAsset['srcset']): string | undefined {
  if (!srcset) return undefined;
  return Object.entries(srcset)
    .sort(([a], [b]) => Number(a) - Number(b))
    .map(([w, url]) => `${url} ${w}w`)
    .join(', ');
}

/** Smallest variant, used as the plain `src` fallback. */
export function fallbackSrc(asset: PublicAsset): string | undefined {
  const entries = Object.entries(asset.srcset ?? {}).sort(([a], [b]) => Number(a) - Number(b));
  return entries[0]?.[1] ?? asset.poster;
}

export const aspectRatio = (asset: Pick<PublicAsset, 'width' | 'height'>) =>
  asset.width / asset.height;
